import { UflaUser } from './ufla-user';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class ProfileResolver {
    private authenticationService = inject(AuthenticationService);

    async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UflaUser> {
        return this.authenticationService.user;
    }
}
